"use client";
import pom from "@/utils/pom";
import { applyDataTestId } from "@/utils/testUtils";
import { useTranslations } from "next-intl";

export const PageHeading = () => {
  const t = useTranslations("PageHeading");
  return (
    <div className="flex flex-col gap-5">
      <h2
        className="text-[36px] leading-[45px] font-bold"
        data-testid={applyDataTestId(pom.giftCard.giftCardPageHeading)}
      >
        {t("title")}
      </h2>
      <p
        className="text-base font-normal  text-[#637381]"
        data-testid={applyDataTestId(pom.giftCard.giftCardPageDescription)}
      >
        {t("description")}
      </p>
    </div>
  );
};
